import React from 'react';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Grid from '@material-ui/core/Grid';
import $ from "jquery";
import { Button, Radio, TextArea, Form, Dropdown, Input, Checkbox, Popup } from 'semantic-ui-react';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import CompareArrowsIcon from '@material-ui/icons/CompareArrows';
import DeleteIcon from '@material-ui/icons/Delete';
import TextField from '@material-ui/core/TextField';
import Loading from '../../loadings';
import ReadCookie from '../../../functions/readcookies';
import Server from '../../../functions/server';
import Executive from '../../dropdown/executive';
import CustomerDetails from '../../others/customerdetails';
import HighlightOff from '@material-ui/icons/HighlightOff';
import Info from '../../others/info';
import QRCode from '../../others/QRCode';
import { GetWebToken, onMessageListener } from '../../../firebase';

class RightSideScreen extends React.Component {

  state = {
    menu: 'Invoice', customerDualScreenorderList: [], expdelivery: this.getFormatedDate(new Date()), 
    invoiceDialog: false, paymentmode:[], otherCharge: 0, otherChargeTax: 0, credit: false, 
    otherChargeInfo: 'otherCharge', executive: 0, dueDate: this.getFormatedDate(new Date(), -10), 
    modeid: 0, mode: '', otherChargeArray: [], customerSelctionDialog: true, expense: [], partcodeOption: [],
    remarks: ''
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month >= 10) ? month : "0"+ month;
    date = (date >= 10) ? date : "0" + date;
    let x = dates.getFullYear() + "-" + month + "-" + date;
    if (interval == 7) {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    return x;
  }

  componentDidMount() {
    this.getCustomer();
    this.OtherCharges();
    this.getPartno();
    this.checkBranch();
    this.getData();
    this.getToken();
  }

  getToken() {
    let context = this;
    GetWebToken((token) => {
      context.setState({ token })
    });
  }

  getPartno() {
    let context = this;
    let data = (ReadCookie("branch"));
    let branch_id;
    for (var i = 0; i < data.length; i++) {
        branch_id = data[i].branch_id;
    }
    context.setState({ load: true, message: 'Getting Spares!!!' })
    $.ajax({
        type: 'POST', data: { 'branch': branch_id, 'customer': 96 },
        url: Server() + 'purchasedetail/getpartcode.php',
        success: function(data) {
        let items = [];
        try {
            data = JSON.parse(data);
            data.map((s) => {
            if (!s.mrp) {
            }
            else {
                items.push(s);
            }
            })
            context.getData(items);
            context.setState({ partcodeOption: items, load: false })
        } catch (e) {
            context.setState({ load: false })
        }
        },
        error: function(err) {
        alert('Try again!!!!')
        context.setState({ load: false })
        }
    });
}

  OtherCharges() {
    let context = this;
    $.ajax({
      type: 'POST',
      url: Server() + 'expensemaster/getplaceorderexpense.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          let expense = [];
          data.map((c) => {
            expense.push({ key: c.name, text: c.name, value: c.name })
          })
          context.setState({ expense })
        } catch (e) {
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  getCustomer() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let executiveId = cook.id;
    $.ajax({
      type: 'POST', data: { 'userId': executiveId },
      url: Server() + 'customer/getallcustomers.php',
      success: function(data) {
        var customer = [];
        let customers = [];
        try {
          customers = JSON.parse(data);
          JSON.parse(data).map((y) => {
            let text = y.id+"->"+y.name+"->"+y.machine_no+"->"+y.taluk+"->"+y.mobile+"->"+y.alt_mobile+'->'+y.emp_id;
            customer.push({key: text, text: text, value: text});
          });
        } catch (e) {
        }
        context.setState({ customerOption: customer, customers })
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  getData1() {
    let items = this.state.partcodeOption;
    try {
      let customerDualScreenorderList = localStorage.getItem("customerDualScreenorderList");  
      customerDualScreenorderList = JSON.parse(customerDualScreenorderList);
      if (!customerDualScreenorderList) {
        return;
      }
      customerDualScreenorderList.map((c) => {
        items.map((v) => {
          if (v.partno == c.partno && v.brand_id == '1') {
            let mrp = this.convertIntoNumber(c.mrp);
            let tax = this.convertIntoNumber(c.tax);
            let qty = this.convertIntoNumber(c.qty);
            c.mrpwithtaxanddiscount = mrp + ((mrp * tax)/100);
            c.totprice = c.mrpwithtaxanddiscount * qty;
            c.ava_stocks = this.convertIntoNumber(v.ava_stocks);
          }
        })
      })
      
      this.setState({ customerDualScreenorderList })
      customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
      localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
    } catch (e) {
    }
  }

  getData() {
    try {
      let customerDualScreenorderList = localStorage.getItem("customerDualScreenorderList");  
      customerDualScreenorderList = JSON.parse(customerDualScreenorderList);
      if (!customerDualScreenorderList) {
        return;
      }
      customerDualScreenorderList.map((c) => {
        let mrp = this.convertIntoNumber(c.mrp);
        let tax = this.convertIntoNumber(c.tax);
        let qty = this.convertIntoNumber(c.qty);
        c.mrpwithtaxanddiscount = mrp + ((mrp * tax)/100);
        c.totprice = c.mrpwithtaxanddiscount * qty;
      })
      this.setState({ customerDualScreenorderList })
      customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
      localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
    } catch (e) {
    }
    
  }

  checkBranch() {
    let data = (ReadCookie("branch"));
    let branchId;
    for (var i = 0; i < data.length; i++) {
      branchId = data[i].branch_id;
    }
    this.setState({ branchId })
    this.getPaymentMode(branchId);
  }

  getPaymentMode(branchId) {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    context.setState({ load: true, message: 'Getting Paymentmode' })
    $.ajax({
      type: 'POST',
      data: { 'executiveid': userId, branchId },
      url: Server() + 'modecontrol/getmode.php',
      success: function(data) {
        let paymentmode = [];
        try {
          data = JSON.parse(data);
          paymentmode.push({ id: 0, mode: 'Online' })
          data.map((c) => { paymentmode.push(c); })
          context.setState({ paymentmode, load: false })
        } catch (e) { context.setState({ load: false }); }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  makeDecimalPoint(value) {
    try { value = value.toFixed(2); }
    catch (e) { value = 0; }
    return value;
  }

  onChangeHandle = (id) => event => {
    let customerDualScreenorderList = this.state.customerDualScreenorderList;
    customerDualScreenorderList.map((c) => {
      if (c.refId == id) { c.qty = event.target.value; }
    })
    this.setState({ customerDualScreenorderList });
    customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
    localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
  };

  deleteItem(id) {
    let customerDualScreenorderList = this.state.customerDualScreenorderList;
    let newcustomerDualScreenorderList = [];
    customerDualScreenorderList.map((c) => {
      if (c.refId != id) {
        newcustomerDualScreenorderList.push(c);
      }
    })
    this.setState({ customerDualScreenorderList: newcustomerDualScreenorderList })
    customerDualScreenorderList = JSON.stringify(newcustomerDualScreenorderList);
    localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
  }

  changeDiscount = (id) => event => {
    let customerDualScreenorderList = this.state.customerDualScreenorderList;
    customerDualScreenorderList.map((v) => {
      if (v.refId == id) {
        v.mrpwithtaxanddiscount =  this.calculateMrpWithDiscount(v.mrp, v.tax, event.target.value);
        v.mrpwithtax = this.calculateMrp(v.mrp, v.tax);
        v.discountamount = ((this.calculateMrp(v.mrp, v.tax)) - (this.calculateMrpWithDiscount(v.mrp, v.tax, event.target.value)));
        v.discount = event.target.value; v.discountper = event.target.value;
      }
    })
    this.setState({ customerDualScreenorderList });
    customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
    localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
  }

  calculateMrpWithDiscount(mrp, tax, discount) {
    mrp = this.convertIntoNumber(mrp);
    tax = this.convertIntoNumber(tax);
    discount = this.convertIntoNumber(discount);
    mrp = mrp + ((mrp * tax)/100);
    mrp = mrp - ((mrp * discount)/100);
    return mrp;
  }

  calculateMrp(mrp, tax) {
    mrp = this.convertIntoNumber(mrp);
    tax = this.convertIntoNumber(tax);
    mrp = mrp + ((mrp * tax)/100);
    return mrp;
  }

  convertIntoNumber(value) {
    try { value = Number(value); }
    catch (e) { value = 0; }
    return value;
  }

  invoiceClearData() {
    let customerDualScreenorderList = this.state.customerDualScreenorderList;
    let newCustomerDualScreenorderList = [];
    customerDualScreenorderList.map((c) => {
      if (c.billtype != 'Invoice') {
        newCustomerDualScreenorderList.push(c);
      }
    })
    this.setState({ customerDualScreenorderList: newCustomerDualScreenorderList, customerSelctionDialog: true })
    newCustomerDualScreenorderList = JSON.stringify(newCustomerDualScreenorderList);
    localStorage.setItem("customerDualScreenorderList", newCustomerDualScreenorderList);
  }

  quotationClearData() {
    let customerDualScreenorderList = this.state.customerDualScreenorderList;
    let newCustomerDualScreenorderList = [];
    customerDualScreenorderList.map((c) => {
      if (c.billtype == 'Invoice') {
        newCustomerDualScreenorderList.push(c);
      }
    })
    this.setState({ customerDualScreenorderList: newCustomerDualScreenorderList })
    newCustomerDualScreenorderList = JSON.stringify(newCustomerDualScreenorderList);
    localStorage.setItem("customerDualScreenorderList", newCustomerDualScreenorderList);
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value, }); }

  handleChangeDeliveryType = (e, { value }) => this.setState({ deliverytype: value })

  selectedSalesType = (f, { value }) => { this.setState({ salesType: value }) }

  paymentdropdown = event => {
    let value = event.target.value; let dropdown =  event.target.value;
    let modeid = value.split('->')[0]; let mode = value.split('->')[1];
    this.setState({ mode, modeid, selectedValue: event.target.value })
  }

  updateExecutive(type, value, data) {
    this.setState({ executive: value, data: data })
  }


  generateInvoice(type) {
    if (!this.props.menuPermission.add) {
      alert('You Are Not Allow To Place Order!!!!');
      return;
    }
    let context = this;
    let customerId = this.state.customerId;
    let branch;
    let branchDetails = (ReadCookie("branch"));
    for (var i = 0; i < branchDetails.length; i++) { branch = branchDetails[i].branch_id; }
    let cook = (ReadCookie("vaigai"));
    let by = cook.id;
    let { salesType, remarks, mode, expense, modeid, customerDualScreenorderList, expdelivery, dueDate, executive, otherChargeArray } = this.state;
    if (otherChargeArray.length > 0) {
      let i = 0;
      otherChargeArray.map((d) => {
        expense.map((c) => {
          if (c.value == d.otherChargeInfo) {
            i = 1;
          }
        })
      })
      if (i == 0) {
        alert('Select Expense Details Properly!!!');
        return;
      }
    }
    if (!salesType) {
      alert('Enter Sales Type!!!');
      return;
    }
    if (!customerId) {
      alert('Select Customer!!!');
      return;
    }
    let status = 'Approved';
    if (type == 'invoice') { status = 'Delivered'; }
    let invoiceList = [];
    customerDualScreenorderList.map((c) => { c.status = status; c.branch = branch; c.rackno = ""; })
    customerDualScreenorderList.map((c) => { if (c.billtype == 'Invoice') { invoiceList.push(c); } })
    otherChargeArray.map((v) => {
      invoiceList.push({  ava_stocks: "", brand: "", discountper: 0, discountrs: 0, partno: "0",
        oldquantity: "", orderdetailsId: 0, part_id: "", partcode: "0", partname: v.otherChargeInfo,
        branch: branch, point: 0, quantity: 1, rackno: v.rackno, status: "Othercharge", tax: v.otherChargeTax,
        totals: v.otherCharge, totprice: v.otherCharge, totprices: v.otherCharge, uprice: v.otherCharge })
    })

    let checkQty = 0;
    let spare_name = '';
    invoiceList.map((c) => {
      let ava_stocks = this.convertIntoNumber(c.ava_stocks);
      let qty = this.convertIntoNumber(c.qty);
      if (ava_stocks < qty) {
        checkQty = c.partno;
        spare_name = c.spare_name;
      }
    })
    if (checkQty != 0) {
      alert(checkQty+'('+spare_name+') Out Of Stock!!!');
      return;
    }
    let totprice = 0;
    invoiceList.map((c) => {
      let price = this.convertIntoNumber(c.totprice);
      totprice = totprice + price;
    })
    
    if (this.state.customerTcs != 0 || this.state.customerTcs != '0') {
      let calculateTCS = ((totprice * 0.1)/100);
      invoiceList.push({  ava_stocks: "", brand: "", discountper: 0, discountrs: 0, partno: "0",
        oldquantity: "", orderdetailsId: 0, part_id: "", partcode: "0", partname: 'TCS',
        branch: branch, point: 0, quantity: 1, rackno: '', status: "Othercharge", tax: 0.1,
        totals: totprice, totprice: calculateTCS, totprices: totprice, uprice: totprice })
    }

    invoiceList.map((c) => {
      let qty = 1;
      if (c.qty) { qty = c.qty; }
      c.quantity = qty;
    })

    if (modeid == 0 || modeid == '0') { mode = ''; }

    let items = JSON.stringify(invoiceList);
    let data1 = { 'type': type, 'id': customerId, 'by': by, 'order': items, 'remarks': remarks, 'd_location': branch, 'paymentMode': mode, 'paymentmodeid': modeid,
                  'executiveId': by, 'expdelivery': expdelivery, 'salesType': context.state.salesType, 'platform': 1, 'point': 10, 'followupexecutive': executive,
                  'dueDate': dueDate, 'redeenpointcheck': 'false', 'customerpoint': 10 };

    $.ajax({ type: 'POST', data: data1,
      url: Server() + 'placeorder/insert.php',
      success: function(data) {
        if (type == 'save') {
          try {
            data = Number(data);
            alert('Order Saved!!!!');
            context.setState({ invoiceList: [], salesType: '', remarks: '', mode: '', modeid: '', salesType: '', selectedValue: '', saveDialog: false })
          } catch (e) {
          }
        }
        else {
          try {
            data = Number(data);
            if (typeof data == 'number') {
              if (context.state.mode == 'Online') {
                context.generateQRCode(data);
              }
              let customerDualScreenorderList = context.state.customerDualScreenorderList;
              let newCustomerDualScreenorderList = [];
              customerDualScreenorderList.map((v) => {
                if (v.billtype != 'Invoice') {
                  newCustomerDualScreenorderList.push(v);
                }
              })
              localStorage.setItem("customerDualScreenorderList", newCustomerDualScreenorderList);
              context.setState({ customerDualScreenorderList: newCustomerDualScreenorderList, otherChargeArray: [], salesType: '', remarks: '', mode: '', modeid: '', salesType: '', selectedValue: '', invoiceDialog: false })
              localStorage.setItem("invoiceList", []);
              let open = Server() + "pdf/placeorderpdf2.php?quotationId="+data+"&customerId="+customerId+"&bankId=0";
              window.open(open);
            }
          } catch (e) {
          }
        }
        context.setState({ load: false })
      },
      error: function(err) {
        context.setState({ load: false, });
      }
    })
  }


  generateQRCode(quotationId) {
    let context = this;
    $.ajax({
      type: 'POST', data: { quotationId, 'token': this.state.token },
      url: Server() + 'quotation/getAmountAndComments.php',
      success: function(data) {
        console.log(data);
        let amount = 0;
        let comments = '';
        try {
          data = JSON.parse(data);
          data.map((c) => { amount = c.amount; comments = c.comments; })
          let url = "https://vaigaiclaas.com/pay?amount="+amount+"&tn="+comments+"&q="+quotationId;
          context.setState({ openQRCodeDialog: true, url })
        } catch (e) {
          alert('Error TO Generate QRCode');
        }
      },
      error: function(err) {
        context.setState({ load: false });
        alert('Try again!!!')
      }
    });
  }

  generateQuotation(type) {
    if (!this.props.menuPermission.add) {
      alert('You Are Not Allow To Place Order!!!!');
      return;
    }
    let context = this;
    let customerId = this.state.customerId;
    let branch;
    let branchDetails = (ReadCookie("branch"));
    for (var i = 0; i < branchDetails.length; i++) { branch = branchDetails[i].branch_id; }
    let cook = (ReadCookie("vaigai"));
    let by = cook.id;
    let { salesType, remarks, mode, expense, modeid, customerDualScreenorderList, expdelivery, dueDate, executive, otherCharge, otherChargeTax, otherChargeArray } = this.state;
    if (otherChargeArray.length > 0) {
      let i = 0;
      otherChargeArray.map((d) => {
        expense.map((c) => {
          if (c.value == d.otherChargeInfo) {
            i = 1;
          }
        })
      })
      if (i == 0) {
        alert('Select Expense Details Properly!!!');
        return;
      }
    }
    if (!customerId) {
      alert('Select Customer!!!');
      return;
    }
    let status = 'Approved';
    if (type == 'quotation') { status = 'Pending For Delivery'; }
    let invoiceList = [];
    customerDualScreenorderList.map((c) => { c.status = status; c.branch = branch; c.rackno = ""; })
    customerDualScreenorderList.map((c) => { if (c.billtype == 'Quotation') { invoiceList.push(c); } })
    otherChargeArray.map((v) => {
      invoiceList.push({  ava_stocks: "", brand: "", discountper: 0, discountrs: 0,
        oldquantity: "", orderdetailsId: 0, part_id: "", partcode: "0",
        partname: v.otherChargeInfo, partno: "0", branch: branch, 
        point: 0, quantity: 1, rackno: v.rackno, status: "Othercharge", tax: v.otherChargeTax,
        totals: v.otherCharge, totprice: v.otherCharge, totprices: v.otherCharge, uprice: v.otherCharge,
       })
    })
    let totprice = 0;
    invoiceList.map((c) => {
      let price = this.convertIntoNumber(c.totprice);
      totprice = totprice + price;
    })
    if (this.state.customerTcs != 0 || this.state.customerTcs != '0') {
      let calculateTCS = ((totprice * 0.1)/100);
      invoiceList.push({  ava_stocks: "", brand: "", discountper: 0, discountrs: 0, partno: "0",
        oldquantity: "", orderdetailsId: 0, part_id: "", partcode: "0", partname: 'TCS',
        branch: branch, point: 0, quantity: 1, rackno: '', status: "Othercharge", tax: 0.1,
        totals: totprice, totprice: calculateTCS, totprices: totprice, uprice: totprice })
    }

    invoiceList.map((c) => {
      let qty = 1;
      if (c.qty) {
        qty = c.qty;
      }
      c.quantity = qty;
    })

    let items = JSON.stringify(invoiceList);
    let data1 = { 'type': type, 'id': customerId, 'by': by, 'order': items, 'remarks': remarks, 'd_location': branch, 'paymentMode': mode, 'paymentmodeid': modeid,
                  'executiveId': by, 'expdelivery': expdelivery, 'salesType': context.state.salesType, 'platform': 1, 'point': 10, 'followupexecutive': executive,
                  'dueDate': dueDate, 'redeenpointcheck': 'false', 'customerpoint': 10 };
    $.ajax({ type: 'POST', data: data1,
      url: Server() + 'placeorder/insert.php',
      success: function(data) {
        try {
          data = Number(data);
          if (typeof data == 'number') {
            let newCustomerDualScreenorderList = [];
            localStorage.setItem("customerDualScreenorderList", newCustomerDualScreenorderList);
            context.setState({ customerDualScreenorderList: newCustomerDualScreenorderList, otherChargeArray: [], salesType: '', remarks: '', mode: '', modeid: '', salesType: '', selectedValue: '', quotationDialog: false })
            localStorage.setItem("invoiceList", newCustomerDualScreenorderList);
            let open = Server() + "pdf/placeorderpdf2.php?quotationId="+data+"&customerId="+customerId+"&bankId=0";
            window.open(open);
          }
        } catch (e) {
        }
        context.setState({ load: false })
      },
      error: function(err) {
        context.setState({ load: false, });
      }
    })
  }

  checkboxHandleChange = () => {
    if (!this.state.credit) {
      this.setState({ credit: !this.state.credit, mode: 'Credit', selectedValue: 'Credit' })
      return;
    }
    this.setState({ credit: !this.state.credit, mode: '', selectedValue: '' })
  }

  checkboxHandleChangeForMove(id) {
    let customerDualScreenorderList = this.state.customerDualScreenorderList;
    customerDualScreenorderList.map((c) => {
      if (c.refId == id) {
        let checked = c.checked;
        if (checked) { checked = false; }
        else { checked = true; }
        c.checked = checked;
      }
    })
    this.setState({ customerDualScreenorderList })
    customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
    localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
  }

  move(type) {
    let customerDualScreenorderList = this.state.customerDualScreenorderList;
    customerDualScreenorderList.map((c) => {
      if (c.checked) {
        c.checked = false;
        if (type == 'Quotation') {
          c.billtype = 'Quotation';
        }
        else {
          c.billtype = 'Invoice';
        }
      }
    })
    this.setState({ customerDualScreenorderList })
    customerDualScreenorderList = JSON.stringify(customerDualScreenorderList);
    localStorage.setItem("customerDualScreenorderList", customerDualScreenorderList);
  }

  addOtherChargeArray() {
    let otherChargeArray = this.state.otherChargeArray;
    let id = 0;
    otherChargeArray.map((c) => { id = c.id; })
    id = id + 1;
    otherChargeArray.push({id: id});
    this.setState({ otherChargeArray })
  }

  deleteOtherChargeArray(id) {
    let otherChargeArray = this.state.otherChargeArray;
    let otherChargeArrayNew = [];
    otherChargeArray.map((c) => { if (c.id != id) { otherChargeArrayNew.push(c); } })
    let updateId = 1;
    otherChargeArrayNew.map((c) => { c.id = updateId++; })
    this.setState({ otherChargeArray: otherChargeArrayNew })
  }

  handleChangeArray = (name, id) => event => {
    let otherChargeArray = this.state.otherChargeArray;
    otherChargeArray.map((c) => {
      if (c.id == id) {
        if (name == 'otherChargeInfo') {
          c.otherChargeInfo = event.target.value;
        }
        if (name == 'otherCharge') {
          c.otherCharge = event.target.value;
        }
        if (name == 'otherChargeTax') {
          c.otherChargeTax = event.target.value;
        }
      }
    })
    this.setState({ otherChargeArray });
  }

  selectedCustomer = (f, { value }) => {
    let customerId = value.split('->')[0];
    let customerName = value.split('->')[1];
    let customerTcs = false;
    this.state.customers.map((c) => {
      if (c.id == customerId) {
        customerTcs = c.tcs;
      }
    })
    this.setState({ customerId, customerSelctionDialog: false, customerName, customerTcs })
  }

  dropDownValues = (value, id) => {
    let otherChargeArray = this.state.otherChargeArray;
    let expense = this.state.expense;
    let values = 0;
    expense.map((c) => {
      if(c.value == value) {
        otherChargeArray.map((c) => {
          if (c.id == id) {
            c.otherChargeInfo = value;
            c.dropDownValues = id;
            c.rackno = id;
          }
        })
      }
    })
    this.setState({ otherChargeArray });
  }

  changeCustomer() {
    this.setState({ customerId: '', customerName: '', customerSelctionDialog: true })
  }

  closeQRcode() {
    this.setState({ openQRCodeDialog: false })
  }

  render() {
    const { fullScreen } = this.props;
    let otherChargeSino = 1;
    let { customerDualScreenorderList } = this.state;
    let salesTypeOption = [
      {key: 'Wholesale', text: 'Wholesale', value: 'Wholesale'},
      {key: 'Counter Sale', text: 'Counter Sale', value: 'Counter Sale'},
      {key: 'Paid(Service)', text: 'Paid(Service)', value: 'Paid(Service)'},
      {key: 'Warranty(Service)', text: 'Warranty(Service)', value: 'Warranty(Service)'},
    ]
    let s = 1;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullScreen={fullScreen} maxWidth={'md'}  open={this.state.customerSelctionDialog}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 300}}> {"Select Customer"} </DialogTitle>
          <DialogContent style={{height: '400px'}}>
            <Dropdown placeholder='Select Customer' style={{marginRight: 20, width: 300}} onChange={this.selectedCustomer} 
                  search selection fluid options={this.state.customerOption} />
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ customerSelctionDialog: false }) }}>Close</Button>
          </DialogActions>
        </Dialog>

        <Dialog fullScreen={fullScreen} maxWidth={'md'}  open={this.state.openQRCodeDialog}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 300}}> {"QR Code"} </DialogTitle>
          <DialogContent style={{height: '400px'}}>
            <QRCode close={this.closeQRcode.bind(this)} size={250} level={'L'} value={this.state.url} />
          </DialogContent>
        </Dialog>


        <Tabs indicatorColor="primary" textColor="primary" variant="fullWidth" >
          <Tab label="Invoice" onClick={ () => { this.setState({ menu: 'Invoice' }) }}
            style={{backgroundColor: this.state.menu == 'Invoice' ? '#A6A5A5': '#EEEEF0', color: this.state.menu == 'Invoice' ? 'white': 'black', fontWeight: 'bold'}} />
          <Tab label="Quotation" onClick={ () => { this.setState({ menu: 'Quotation' }) }}
            style={{backgroundColor: this.state.menu == 'Quotation' ? '#A6A5A5': '#EEEEF0', color: this.state.menu == 'Quotation' ? 'white': 'black', fontWeight: 'bold'}} />
        </Tabs>
        <div style={{margin: '4%', display: 'flex'}}>
            <div>Selected Customer : </div>
            <CustomerDetails customerName={this.state.customerName} customerId={this.state.customerId} />
            <HighlightOff style={{color: 'red', cursor: 'pointer', marginLeft: '2%'}} onClick={this.changeCustomer.bind(this)} />
        </div>
        <table id='table' width='100%'>
          <tr>
            <th id='th'><center>Sino</center></th>
            <th id='th'><center>Move</center></th>
            <th id='th'><center>Partno</center></th>
            <th id='th'><center>Spare Name</center></th>
            <th id='th'><center>Qty</center></th>
            <th id='th'><center>Tax</center></th>
            { this.state.display == 1 ?
              (
                <th id='th'><center>Dis(%)</center></th>
              ):''
            }
            { this.state.display == 1 ?
              (
                <th id='th'><center>Dis Rs.</center></th>
              ):''
            }

            <th id='th'><center>Mrp</center></th>
            <th id='th'><center>Action</center></th>
          </tr>
          {
            customerDualScreenorderList.map((c) => {
              if (c.billtype == this.state.menu) {
                let ava_stocks = this.convertIntoNumber(c.ava_stocks);
                let qty = this.convertIntoNumber(c.qty);
                let backgroundColor = "white";
                if (ava_stocks < qty) {
                  backgroundColor = "#FACACA";
                }
                return (
                  <tr style={{backgroundColor: backgroundColor}}>
                    <td><center>{s++}</center></td>
                    <td><center><Checkbox label='' onChange={this.checkboxHandleChangeForMove.bind(this, c.refId)} checked={c.checked} /></center></td>
                    <td><center>{c.partno}</center></td>
                    <td><center>{c.spare_name}</center></td>
                    <td style={{width: 25}}>
                      <Popup content={<div>{'Stock Available in Branch:  '+ava_stocks}</div>} trigger={
                        <TextField id="standard-required" value={c.qty} 
                        onChange={this.onChangeHandle(c.refId)} style={{width: 25}}  />
                      } />
                      
                    </td>
                    <td><center>{c.tax}</center></td>
                    { this.state.display == 1 ?
                      (
                        <td style={{width: 25}}><TextField id="standard-required" value={c.discount} onChange={this.changeDiscount(c.refId)} style={{width: '100%'}}  /></td>
                      ):''
                    }
                    { this.state.display == 1 ?
                      (
                        <td><center>{(c.qty * this.makeDecimalPoint(c.discountamount))}</center></td>
                      ):''
                    }

                    <td><center>{(c.qty * this.makeDecimalPoint(c.mrpwithtaxanddiscount))}</center></td>
                    <td>
                      <center style={{width: '100%', display: 'flex'}}>
                        <div style={{width: '50%'}}><Info partno={c.partno} brand={1} /></div>
                        <div style={{width: '50%'}}><DeleteIcon style={{cursor: 'pointer'}} onClick={this.deleteItem.bind(this, c.refId)} /></div>
                      </center>
                    </td>
                  </tr>
                )
              }
            })
          }
        </table>

        { this.state.menu == 'Invoice' ?
          (
            <center style={{marginTop: 10}}>
              <Button primary onClick={this.move.bind(this, 'Quotation')}>Move</Button>
              <Button primary onClick={this.invoiceClearData.bind(this)}>Clear Data</Button>
              <Button primary onClick={ () => { this.setState({ saveDialog: true }) }}>Save</Button>
              <Button primary onClick={ () => { this.setState({ invoiceDialog: true }) }}>Submit</Button>
            </center>
          ):
          (
            <center style={{marginTop: 10}}>
              <Button primary onClick={this.move.bind(this, 'Invoice')}>Move</Button>
              <Button primary onClick={this.quotationClearData.bind(this)}>Clear Data</Button>
              <Button primary onClick={ () => { this.setState({ quotationDialog: true }) }}>Submit</Button>
            </center>
          )
        }

        <Dialog fullScreen={fullScreen} maxWidth={'md'} onClose={ () => { this.setState({ invoiceDialog: false }) }} open={this.state.invoiceDialog}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 900}}> {"Add Remark & Conform Order"} </DialogTitle>
          <DialogContent>
            <div style={{display: 'flex'}}>
              <div>
                Expected Delivary Date<br/>
                <input type="date" id="date" value={this.state.expdelivery} style={{height: 35, marginTop: 5 }} onChange={this.handleChange('expdelivery')} />
              </div>
              <div style={{marginLeft: 20, width: '30%'}}>
                Delivery Type<br/>
                <div style={{display: 'flex', marginTop: 10}}>
                  <Radio label='Pickup' name='radioGroup' value='Pickup' checked={this.state.deliverytype === 'Pickup'} onChange={this.handleChangeDeliveryType} /><br/>
                  <Radio label='Delivery' name='radioGroup' value='Delivery' checked={this.state.deliverytype === 'Delivery'} onChange={this.handleChangeDeliveryType} style={{marginLeft: 10}} />
                </div>
              </div>
              <div style={{marginLeft: 30}}>
                Sales Type<br/>
                <Dropdown style={{width: 100}} search onChange={this.selectedSalesType} selection options={salesTypeOption} value={this.state.salesType} />
              </div>

            </div>
            <div style={{display: 'flex'}}>
              <div style={{width: '30%', marginTop: 8}}>
                Payment Mode<br/>
                <datalist id="suggestions2">
                    {this.state.paymentmode.map((x) => {
                      return ( <option id='box2'>{x.id+'->'+x.mode}</option> )
                    })}
                </datalist>
                <input style={{height: 35, width: '100%'}} onChange={this.paymentdropdown} autoComplete="on" list="suggestions2" value={this.state.selectedValue}/>
              </div>

              <div style={{marginTop: '5%', marginLeft: 20}}>
                <Checkbox label='Credit' onChange={this.checkboxHandleChange} checked={this.state.credit} />
              </div>
              <div style={{marginLeft: 10, marginTop: 8}}>
                Due Date<br/>
                <input type="date" id="date" value={this.state.dueDate} style={{height: 35 }} onChange={this.handleChange('dueDate')} />
              </div>
              <div style={{marginLeft: 10, marginTop: 8, width: '30%'}}>
                Executive<br/>
                <Executive update={this.updateExecutive.bind(this)} />
              </div>
            </div>
            <table width="100%" id="table" style={{marginTop: 5}}>
              <tr>
                <th id='th' style={{width: '10%'}}>Si.No</th>
                <th id='th' style={{width: '55%'}}>Info</th>
                <th id='th' style={{width: '20%'}}>Amount</th>
                <th id='th' style={{width: '15%'}}>Tax</th>
                <th id='th' style={{width: '10%'}}>Delete</th>
              </tr>
              {
                this.state.otherChargeArray.map((c) => {
                  return (
                    <tr>
                      <td><center>{c.id}</center></td>
                      <td>
                      <datalist id="suggestionsexpense">
                          {this.state.expense.map((c) => {
                            return (
                              <option id='box'>{c.value}</option>
                            )
                          })}
                        </datalist>
                        <input style={{height: 35, width: '100%'}} onChange={ (event) => { this.dropDownValues(event.target.value, c.id) }} autoComplete="on"
                        list="suggestionsexpense" value={c.otherChargeInfo} id={1}/>
                      </td>
                      <td><Input value={c.otherCharge} fluid onChange={this.handleChangeArray('otherCharge', c.id)} /></td>
                      <td><Input value={c.otherChargeTax} fluid onChange={this.handleChangeArray('otherChargeTax', c.id)} /></td>
                      <td><div style={{color: 'red' }} onClick={this.deleteOtherChargeArray.bind(this, c.id)}> Remove </div></td>
                    </tr>
                  )
                })
              }
            </table>
            <center style={{marginTop: 10}}><Button onClick={this.addOtherChargeArray.bind(this)}>Add</Button></center>
            <div>
              Remark`s<br/>
              <Form>
                <TextArea placeholder='Remark...' onChange={this.handleChange('remarks')} value={this.state.remarks}/>
              </Form>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ invoiceDialog: false }) }}>Cancel</Button>
            <Button onClick={this.generateInvoice.bind(this, 'invoice')}>Submit</Button>
          </DialogActions>
        </Dialog>

        <Dialog fullScreen={fullScreen} maxWidth={'md'} onClose={ () => { this.setState({ quotationDialog: false }) }} open={this.state.quotationDialog}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 600}}> {"Add Remark & Conform Order"} </DialogTitle>
          <DialogContent>
            Expected Delivary Date<br/>
            <input type="date" id="date" value={this.state.expdelivery} style={{height: 35 }} onChange={this.handleChange('expdelivery')} />
            <table width="100%" id="table" style={{marginTop: 5}}>
              <tr>
                <th id='th' style={{width: '8%'}}>Si.No</th>
                <th id='th' style={{width: '55%'}}>Info</th>
                <th id='th' style={{width: '20%'}}>Amount</th>
                <th id='th' style={{width: '15%'}}>Tax</th>
                <th id='th' style={{width: '10%'}}>Delete</th>
              </tr>
              {
                this.state.otherChargeArray.map((c) => {
                  return (
                    <tr>
                      <td><center>{c.id}</center></td>
                      <td>
                        
                        <datalist id="suggestionsexpense">
                          {this.state.expense.map((c) => {
                            return (
                              <option id='box'>{c.value}</option>
                            )
                          })}
                        </datalist>
                        <input style={{height: 35, width: '100%'}} onChange={ (event) => { this.dropDownValues(event.target.value, c.id) }} autoComplete="on"
                        list="suggestionsexpense" value={c.otherChargeInfo} id={1}/>
                      
                      
                      <Input value={c.otherChargeInfo} fluid onChange={this.handleChangeArray('otherChargeInfo', c.id)} /></td>
                      <td><Input value={c.otherCharge} fluid onChange={this.handleChangeArray('otherCharge', c.id)} /></td>
                      <td><Input value={c.otherChargeTax} fluid onChange={this.handleChangeArray('otherChargeTax', c.id)} /></td>
                      <td><div style={{color: 'red' }} onClick={this.deleteOtherChargeArray.bind(this, c.id)}> Remove </div></td>
                    </tr>
                  )
                })
              }
            </table>
            <center style={{marginTop: 10}}><Button onClick={this.addOtherChargeArray.bind(this)}>Add</Button></center>
            <div>
              Remark`s<br/>
              <Form>
                <TextArea placeholder='Remark...' onChange={this.handleChange('remarks')} value={this.state.remarks}/>
              </Form>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ quotationDialog: false }) }}>Cancel</Button>
            <Button onClick={this.generateQuotation.bind(this, 'quotation')}>Submit</Button>
          </DialogActions>
        </Dialog>


        <Dialog fullScreen={fullScreen} maxWidth={'md'} onClose={ () => { this.setState({ saveDialog: false }) }} open={this.state.saveDialog}
          aria-labelledby="responsive-dialog-title" >
          <DialogTitle id="responsive-dialog-title" style={{width: 600}}> {"Add Remark & Conform Order"} </DialogTitle>
          <DialogContent>
            Expected Delivary Date<br/>
            <input type="date" id="date" value={this.state.expdelivery} style={{height: 35 }} onChange={this.handleChange('expdelivery')} />

            <table width="100%" id="table" style={{marginTop: 5}}>
              <tr>
                <th id='th' style={{width: '10%'}}>Si.No</th>
                <th id='th' style={{width: '55%'}}>Info</th>
                <th id='th' style={{width: '20%'}}>Amount</th>
                <th id='th' style={{width: '15%'}}>Tax</th>
                <th id='th' style={{width: '10%'}}>Delete</th>
              </tr>
              {
                this.state.otherChargeArray.map((c) => {
                  return (
                    <tr>
                      <td><center>{c.id}</center></td>
                      <td><Input value={c.otherChargeInfo} fluid onChange={this.handleChangeArray('otherChargeInfo', c.id)} /></td>
                      <td><Input value={c.otherCharge} fluid onChange={this.handleChangeArray('otherCharge', c.id)} /></td>
                      <td><Input value={c.otherChargeTax} fluid onChange={this.handleChangeArray('otherChargeTax', c.id)} /></td>
                      <td><div style={{color: 'red' }} onClick={this.deleteOtherChargeArray.bind(this, c.id)}> Remove </div></td>
                    </tr>
                  )
                })
              }
            </table>
            <center style={{marginTop: 10}}><Button onClick={this.addOtherChargeArray.bind(this)}>Add</Button></center>


            <div>
              Remark`s<br/>
              <Form>
                <TextArea placeholder='Remark...' onChange={this.handleChange('remarks')} value={this.state.remarks}/>
              </Form>
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ saveDialog: false }) }}>Cancel</Button>
            <Button onClick={this.generateInvoice.bind(this, 'save')}>Submit</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default RightSideScreen;
